import React from 'react';
import { X, ShieldAlert, CheckCircle, ArrowRight, User } from 'lucide-react';
import { WorkflowRunItem } from '../api';

interface OperatorResolutionModalProps {
  isOpen: boolean;
  onClose: () => void;
  caller: WorkflowRunItem | null;
}

export function OperatorResolutionModal({
  isOpen,
  onClose,
  caller,
}: OperatorResolutionModalProps) {
  if (!isOpen || !caller) return null;

  const phone = caller.customer_phone || caller.contact_id || 'Unknown Phone';
  const name = caller.contact_name || `Contact ${caller.contact_id || caller.run_id}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-xs animate-in fade-in">
      <div className="w-full max-w-lg rounded-2xl bg-elevated shadow-2xl border border-line overflow-hidden animate-in zoom-in-95 duration-200">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-line bg-warning-soft/50">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-warning-soft text-warning font-bold border border-warning/30">
              <ShieldAlert className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-sm font-bold text-ink">Resolve Ambiguous Outcome</h3>
              <p className="text-xs text-ink-3 font-mono">{phone}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-1.5 text-ink-3 hover:bg-soft hover:text-ink-2 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Content Body */}
        <div className="p-6 flex flex-col items-center justify-center text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-warning-soft text-warning mb-3 border border-warning/30">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <h4 className="text-base font-bold text-ink">Operator Resolution</h4>
          <p className="mt-1 text-xs text-ink-3 max-w-sm leading-relaxed">
            Human-in-the-loop actions, outfield backfills, and step advance routing for <strong className="text-ink">{name}</strong> will be connected here.
          </p>

          <div className="mt-5 w-full rounded-xl border border-line bg-soft/70 p-3.5 text-left text-xs text-ink-2 space-y-1.5 font-mono">
            <div className="flex justify-between">
              <span className="text-ink-3">Current Node:</span>
              <span className="font-semibold text-ink">{caller.current_node_id}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-ink-3">Status:</span>
              <span className="font-semibold text-warning">{caller.status}</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2.5 px-6 py-4 border-t border-line bg-soft/50">
          <button
            onClick={onClose}
            className="rounded-lg border border-line bg-elevated px-4 py-2 text-xs font-semibold text-ink-2 shadow-xs hover:bg-soft transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
